{
  "id": 37,
  "location": "paris",
  "difficulty": "normal",
  "moves": 32,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "croissant", "count": 38 },
    { "type": "collect", "kind": "latte", "count": 38 }
  ],
  "stars": [4340, 5310],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . # # . . .",
    ". . . # # . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.677, "movesLeft": 5.8, "closeLosses": 0.097, "target": 0.68 }
}
